module.exports = __webpack_public_path__ + "img/CE8C15_EAC79B_DDAB57_F9C962-256px.e375c2f5.png";